import createToolTip from '../createToolTip';

export default function btnConfirmEvent(input, actions, event, btnConfirm) {
  const initToolTip = createToolTip();
  if (input.classList.contains('has-error') && input.value !== '') {
    input.classList.remove('has-error');
  }

  if (input.value === '' && input.classList.contains('required')) {
    btnConfirm.classList.add('display--none');
    input.focus();
    input.classList.add('has-error');
    input.classList.add('invalid');
    initToolTip.style.bottom = `${ input.offsetHeight }px`;
    input.parentElement.appendChild(initToolTip);
  }

  if (!input.classList.contains('has-error')) {
    input.value = input.value;
    input.name = input.value;

    actions.classList.add('display--none');

    const toolTip = event.target.parentElement.parentElement.parentElement.querySelector('.tooltip--inline-edit');
    const parentElement = event.target.parentElement.parentElement.classList.contains('inline-edit') ?
      event.target.parentElement.parentElement :
      event.target.parentElement.parentElement.parentElement;
    if (toolTip) {
      parentElement.removeChild(toolTip);
    }
  }

  return input;
}



// WEBPACK FOOTER //
// ./js/components/tables/inline-edit/events/btnConfirmEvent.js